import { format, subDays } from 'date-fns';

type DatePeriod = 'all' | '7d' | '1m' | '3m' | '6m' | '1y' | 'custom';

const PERIOD_TO_DAYS: Readonly<Partial<Record<DatePeriod, number>>> = {
  '7d': 7,
  '1m': 30,
  '3m': 90,
  '6m': 180,
  '1y': 365,
};

const EMPTY_DATE_RANGE = { fromDate: '', toDate: '' };

export const getDateRangeByPeriod = (
  period: string,
  baseDate = new Date()
): { fromDate: string; toDate: string } => {
  const normalizedPeriod = period as DatePeriod;

  if (normalizedPeriod === 'all' || normalizedPeriod === 'custom') {
    return EMPTY_DATE_RANGE;
  }

  const dayOffset = PERIOD_TO_DAYS[normalizedPeriod];
  if (!dayOffset) {
    return EMPTY_DATE_RANGE;
  }

  const dateFormat = 'dd/MM/yyyy';
  return {
    fromDate: format(subDays(baseDate, dayOffset), dateFormat),
    toDate: format(baseDate, dateFormat),
  };
};
